export const SEO_DATA_SELECTOR_COMPARISON_CARD = 'compare-card'

export const TOP_COMPARISONS = [
  {
    models: [
      {
        name: 'Galaxy S10',
      },
      {
        name: 'iPhone 11',
      },
    ],
    link: {
      type: 'internal',
      name: 'compare_products',
      params: {
        productA: 'Galaxy-S10',
        productB: 'iPhone-11',
      },
      query: {},
      hash: {},
    },
    image:
      'https://d37cfnv61yd15h.cloudfront.net/model_comparison/images/comparison-image-1.jpg',
    customContent: {
      metaTitle: 'Galaxy S10 vs iPhone 11',
      metaDescription: 'Better make and newer model - go for iPhone 11',
      title: 'Galaxy S10 vs iPhone 11',
      content:
        '<p>Better make and newer model - go for <strong>iPhone 11</strong></p>',
      cardDescription: "Who's the best old school ?",
    },
  },
  {
    models: [
      {
        name: 'iPhone X',
      },
      {
        name: 'iPhone XR',
      },
    ],
    link: {
      type: 'internal',
      name: 'compare_products',
      params: {
        productA: 'iPhone-X',
        productB: 'iPhone-XR',
      },
      query: {},
      hash: {},
    },
    image:
      'https://d37cfnv61yd15h.cloudfront.net/model_comparison/images/comparison-image-2.jpg',
    customContent: {
      metaTitle: 'iPhone XR vs iPhone X',
      metaDescription:
        'iPhone XR vs iPhone X - Is the R worth it or the X enough?',
      title: 'iPhone XR vs iPhone X - Is the R worth it or the X enough?',
      content:
        '<p>iPhone XR vs iPhone X - Is the R worth it or the X enough?</p>',
      cardDescription:
        'Is the R worth it or is the X enough? Find out by clicking the card!!!',
    },
  },
]
